import { jsx as _jsx } from "react/jsx-runtime";
import { Gear } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { memo, useMemo } from "react";
import { SelectedOptionIcon } from "~/components/AssetModal/Visualizer/VideoVisualizer/VideoVisualizerInner/shared/SelectedOptionIcon";
import { DropdownMenuWithActionSheet } from "~/components/Menus/DropdownMenuWithActionSheet";
export const VideoQualityOptions = /*#__PURE__*/ memo((param)=>{
    let { currentResolutionIndex, onSelectVideoResolution, resolutionOptions, container } = param;
    const options = useMemo(()=>{
        const optionsArray = [
            {
                id: "quality",
                label: "Quality",
                type: "title"
            },
            {
                id: "resolution Auto",
                label: "Auto",
                onSelect: ()=>onSelectVideoResolution(-1),
                suffix: currentResolutionIndex === -1 ? /*#__PURE__*/ _jsx(SelectedOptionIcon, {}) : null,
                type: "item"
            }
        ];
        resolutionOptions.map((res, index)=>{
            const resolution = Math.min(res.width, res.height);
            optionsArray.push({
                id: "resolution ".concat(resolution, "}"),
                label: "".concat(resolution, "p"),
                onSelect: ()=>onSelectVideoResolution(index),
                suffix: index === currentResolutionIndex ? /*#__PURE__*/ _jsx(SelectedOptionIcon, {}) : null,
                type: "item"
            });
        });
        return optionsArray;
    }, [
        currentResolutionIndex,
        onSelectVideoResolution,
        resolutionOptions
    ]);
    return /*#__PURE__*/ _jsx(DropdownMenuWithActionSheet, {
        "data-theme": "dark",
        title: "Quality",
        container: container,
        trigger: /*#__PURE__*/ _jsx(IconButton, {
            label: "Quality",
            icon: Gear,
            size: "large",
            appearance: "ghost",
            className: "ml-2 text-pigeon-100 hover:bg-pigeon-700 hover:text-pigeon-50 active:bg-pigeon-700 active:text-pigeon-50"
        }),
        options: options
    });
});
VideoQualityOptions.displayName = "VideoQualityOptions";
